import BillingsOrderCargoRailyAddRequest, {
  BillingsOrderCargoRailyAddRequestBillingNode,
} from "../../../../../api/raily/billings/order/cargo-raily/add/billings-order-cargo-raily-add.request";
import BillingsOrderCargoRailyAddParams, {
  BillingsOrderCargoRailyAddParamsBillingNode,
} from "./billings-order-cargo-raily-add-params";

const createBillingNode = (
  billingsNode: BillingsOrderCargoRailyAddParamsBillingNode,
): BillingsOrderCargoRailyAddRequestBillingNode => {
  return {
    id: billingsNode.id,
    nodeId: billingsNode.nodeId,
    lat: billingsNode.lat,
    lon: billingsNode.lon,
    description: billingsNode.description,
    checkoutDate: billingsNode.checkoutDate,
    checkoutEventId: billingsNode.checkoutEventId,
    plannedDate: billingsNode.plannedDate,
    orderId: billingsNode.orderId,
    distance: billingsNode.distance,
    plannedDistance: billingsNode.plannedDistance,
    haltingTime: billingsNode.haltingTime,
    highwayCharge: billingsNode.highwayCharge,
    allowCharge: billingsNode.allowCharge,
    editableCoordinates: billingsNode.editableCoordinates,
  };
};

const createBillingNodes = (
  billingsNodes: BillingsOrderCargoRailyAddParamsBillingNode[],
): BillingsOrderCargoRailyAddRequestBillingNode[] => {
  return billingsNodes.map(createBillingNode);
};

const create = (
  params: BillingsOrderCargoRailyAddParams,
): BillingsOrderCargoRailyAddRequest => {
  return {
    billingNodes: createBillingNodes(params.billingNodes),
    discount: params.discount,
    orderUuid: params.orderUuid,
  };
};

const billingsOrderCargoRailyAddParamsFactory = {
  create,
};

export default billingsOrderCargoRailyAddParamsFactory;
